module.exports = __webpack_public_path__ + "img/ultraClearImg.95f5ea0c.jpg";